export default class DifalNC {
  constructor(
    UfDestino = "",
    UfOrigem = "",
    ValorTotal = 0,
    AliquotaInterna = 0,
    FundoCombatePobreza = 0,
    IcmsBool = false,
    Importada = false,
    ReInterestadual = 0,
    ReInterna = 0
    ) {
    this.UfDestino = UfDestino;
    this.UfOrigem = UfOrigem;
    this.ValorTotal = ValorTotal;
    this.AliquotaInterna = AliquotaInterna;
    this.FundoCombatePobreza = FundoCombatePobreza;
    this.IcmsBool = IcmsBool;
    this.Importada = Importada;
    this.ReInterestadual = ReInterestadual
    this.ReInterna = ReInterna
  }

  converter() {
    this.ValorTotal = this.ValorTotal.replaceAll(".", "");
    this.ValorTotal = this.ValorTotal.replaceAll(",", ".");
    this.ValorTotal = parseFloat(this.ValorTotal);
    this.AliquotaInterna = parseFloat(this.AliquotaInterna);
    this.FundoCombatePobreza = parseInt(this.FundoCombatePobreza);
    if (this.IcmsBool == "true") this.IcmsBool = true;
    else if (this.IcmsBool == "false") this.IcmsBool = false;
  }

  zerar() {
    this.UfDestino = "";
    this.UfOrigem = "";
    this.ValorTotal = 0;
    this.AliquotaInterna = 0;
    this.FundoCombatePobreza = 0;
    this.IcmsBool = false;
    this.Importada = false;
    this.ReInterestadual = 0
    this.ReInterna = 0
  }

  valida() {
    if (
      this.UfDestino &&
      this.UfOrigem &&
      this.ValorTotal > 0 &&
      this.AliquotaInterna > 0 &&
      //this.FundoCombatePobreza &&
      (this.IcmsBool || !this.IcmsBool)
      //this.Importada
    )
      return true;

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/models/DifalNC.js